import { RouteConfig } from 'vue-router';
import { IMenuItem, IMenuGroup } from '@/interfaces/menu';

export function parseRoutes(routeArr: RouteConfig[]): any {
  const NOT_FOUND = -1;

  const flatRoutes = routeArr.reduce((acc: any, cur: RouteConfig) => {
    let items: IMenuItem[] = [];

    if (!!cur.children && !!cur.children.length) {
      items = cur.children
        .filter((i) => {
          if (!i.meta) {
            return true;
          }
          return !i.meta.hideFromMenu;
        })
        .map((i) => {
          return {
            path: i.path,
            name: i.name,
            icon: i.meta && i.meta.icon,
            permissions:
              !!i.meta && !!i.meta.permissions ? i.meta.permissions : [],
          };
        });
    }

    if (!cur.meta.hideFromMenu) {
      items.push({
        path: cur.path,
        name: cur.name,
        icon: cur.meta && cur.meta.icon,
        permissions:
          !!cur.meta && !!cur.meta.permissions ? cur.meta.permissions : [],
      });
    }

    acc.push(...items);
    return acc;
  }, []);

  const groupedRoutes = flatRoutes.reduce(
    (acc: IMenuGroup[], cur: IMenuItem) => {
      let groupName = null;
      let itemName = null;

      if (cur.name.indexOf('\|') !== NOT_FOUND) {
        [groupName, itemName] = cur.name.split('\|');
      } else {
        itemName = cur.name;
      }

      let groupIndex = acc.findIndex((i) => i.name === groupName);

      if (!!groupName && groupIndex === NOT_FOUND) {
        const group = {
          name: groupName,
          items: [],
          isOpen: false,
          permissions: [],
        };
        acc.push(group);
        groupIndex = acc.length - 1;
      } else if (!groupName && !!itemName) {
        const item = {
          name: itemName,
          path: cur.path,
          icon: cur.icon,
          permissions: cur.permissions || [],
        };
        acc.push(item);
      }

      if (!!groupName) {
        acc[groupIndex].items.push({
          ...cur,
          name: itemName || groupName,
          permissions: cur.permissions || [],
        });
        if (!!cur.permissions) {
          acc[groupIndex].permissions = acc[groupIndex].permissions.concat(
            cur.permissions,
          );
        }
      }

      return acc;
    },
    [],
  );

  return groupedRoutes.map((i) => {
    if (!!i.items) {
      // i.items = i.items.sort((itemA, itemB) => {
      //   if (itemA.name < itemB.name) {
      //     return -1;
      //   }
      //   if (itemA.name > itemB.name) {
      //     return 1;
      //   }
      //   return 0;
      // });
    }
    return i;
  });
}
